import axios from "../AxiosInterCeptor/AxiosInterCeptor";

const URL = process.env.React_App_BaseUrl;

// Dedicated bulk-upload service (mirrors the backend bulkUpload module).
// Used by the User Payable bulk upload dialog (and reusable for other screens).

export const VerifyUserPayableBulkUpload = (formData) => {
  return axios
    .post(`${URL}/verifyUserPayableBulkUpload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Verification failed";
      return { error: true, message };
    });
};

export const BulkUploadUserPayable = (formData) => {
  return axios
    .post(`${URL}/bulkUploadUserPayable`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message || error?.message || "Upload failed";
      return { error: true, message };
    });
};

export const VerifyBranchPayableBulkUpload = (formData) => {
  return axios
    .post(`${URL}/verifyBranchPayableBulkUpload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Verification failed";
      return { error: true, message };
    });
};

export const BulkUploadBranchPayable = (formData) => {
  return axios
    .post(`${URL}/bulkUploadBranchPayable`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message || error?.message || "Upload failed";
      return { error: true, message };
    });
};

export const VerifyCommisionReceivableBulkUpload = (formData) => {
  return axios
    .post(`${URL}/verifyCommisionReceivableBulkUpload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Verification failed";
      return { error: true, message };
    });
};

export const BulkUploadCommisionReceivable = (formData) => {
  return axios
    .post(`${URL}/bulkUploadCommisionReceivable`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message || error?.message || "Upload failed";
      return { error: true, message };
    });
};

export const GetBulkUploadFiles = (body) => {
  return axios
    .post(`${URL}/getBulkUploadFiles`, body)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to load bulk upload history";
      return { error: true, message };
    });
};

export const GetBulkUploadFileDownloadUrl = (id) => {
  return axios
    .get(`${URL}/getBulkUploadFileDownloadUrl/${id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        return { error: true, message: res.message };
      }
      return res;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to download file";
      return { error: true, message };
    });
};
